module.exports = __webpack_public_path__ + "img/down-arrow.c421cb32.svg";